import { useNavigate } from 'react-router';

import { DraftNotice } from 'components/ui/draft-notice';

import './styles.scss';

export default function PartialTask({ onClose }: { onClose: () => void }) {
  const navigate = useNavigate();

  return (
    <DraftNotice
      storageKey="partialTaskMinimized"
      title="Você possui uma realização em preenchimento"
      actionLabel="Cadastrar Realização Destaque"
      onResume={() => navigate('/realizacao-destaque/cadastrar')}
      onClose={onClose}
    >
      <p className="m-0">Identificamos que você iniciou o cadastro de uma Realização Destaque, mas ainda não concluiu o envio.</p>
      <p className="m-0">Suas informações foram salvas automaticamente para que você possa continuar de onde parou.</p>
      <p className="m-0">Clique no botão abaixo para retomar o preenchimento e finalizar o cadastro.</p>
    </DraftNotice>
  );
}
